import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'

// this is the max Integer value allowed in Java
// http://www.java2s.com/Tutorial/Java/0040__Data-Type/IntegerMAXMINVALUE.htm
var MAX_ID = 2147483647

var IdTracker = function() {
	this.loadedIds = []
	this.invalidIds = []
}
_.extend(IdTracker.prototype, {

	// returns the IDs that need to be loaded out of those passed in, and
	// keeps track that the given IDs were loaded
	load: function(requestedIds) {
		var neededIds = _.chain(requestedIds)
		// filter out invalid IDs to avoid blowups on the server.  For purposes
		// of input validation, the code calling this can always count on a
		// missing data for an ID to mean there is no metric with that ID
			.filter(function(id) { return id <= MAX_ID })
			.difference(this.loadedIds)
			.difference(this.invalidIds).value()
		this.loadedIds = this.loadedIds.concat(neededIds)
		return neededIds
	},

	// records the results of a retrieval and makes note of any IDs that are
	// invalid
	results: function(neededIds, retrievedIds) {
		var missingIds = _.difference(neededIds, retrievedIds)
		this.invalidIds = this.invalidIds.concat(missingIds)
	}

})

/**
 * The "data" param can be an array of scorecard item and initiative data.
 */
var LabelOrgScoringType = function(data) {
	this.scorecardTracker = new IdTracker()
	this.initiativeTracker = new IdTracker()
	this.data = {
		'scorecard-item': {},
		initiative: {}
	}
	this.index(data)
}
_.extend(LabelOrgScoringType.prototype, Backbone.Events, {

	url: 'api/domain/label-org-scoring-type',

	load: function(scorecardIds, initiativeIds, success) {
		scorecardIds = this.scorecardTracker.load(scorecardIds)
		initiativeIds = this.initiativeTracker.load(initiativeIds)
		if (scorecardIds.length == 0 && initiativeIds.length == 0) {
			success()
			return
		}

		var self = this
		$.get(this.url, {
			scorecardNodeIds: scorecardIds,
			initiativeIds: initiativeIds
		}, function(results) {
			self.index(results)
			success(results)
		})
	},

	index: function(results) {
		_.each(results, function(result) {
			this.data[result.type][result.id] = result
		}.bind(this))
	},

	// type is either scorecard-item or initiative
	get: function(type, id) {
		return this.data[type][id]
	}

})

_.extend(LabelOrgScoringType, { IdTracker })
export default LabelOrgScoringType
export { IdTracker }

LabelOrgScoringType.__filename__ = 'scorecards/edit/label-org-scoring-type.js'
